import React, { useEffect, useState } from "react"
import { withRouter, useParams } from "react-router-dom"
import { connect, useSelector } from "react-redux"
import moment from "moment"
import { isEmpty } from "lodash"
import {
  Col,
  UncontrolledTooltip,
  Button,
  Table,
  Row,
} from "reactstrap"
import PropTypes from "prop-types"
import ToolkitProvider from "react-bootstrap-table2-toolkit"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import BootstrapTable from "react-bootstrap-table-next"
import * as deliverAction from "../../store/b3BlcmF0aW9uc0/actions"
import * as historyAction from "store/Y3JtTWFuYWdlQ2xpZW50/actions"
import Modal from "react-bootstrap/Modal"
// import "./styles.scss"


const OperationsDeliverables = (props) => {
  const { dispatch } = props
  let { id } = useParams()
  const payload = {
    leadId: id,
    type: "freelancerQc"
  }
  useEffect(() => {
    dispatch(deliverAction.loadDeliverables(payload))
    dispatch(deliverAction.loadDeliverMetaData())
  }, [1])

  const update = useSelector(state => state.operationsFollowUp)
  const { deliver_list = [], deliverMetaData } = update
  const sessionUpdate = useSelector((specificstate) => specificstate.session)
  const { user = [] } = sessionUpdate

  //date format from localstorage
  const authUser = localStorage.getItem("authUser")

  const dateLogin = JSON.parse(authUser)

  const setDate =
    !isEmpty(dateLogin) && dateLogin.setting && dateLogin.setting.dateFormate
      ? dateLogin.setting.dateFormate.toUpperCase()
      : !isEmpty(user) && user.setting && user.setting.dateFormate
        ? user.setting.dateFormate.toUpperCase()
        : []

  const dateFormat = !isEmpty(setDate) && setDate ? setDate : ""

  const [deliverablesModal, setDeliverablesModal] = useState(false)
  const [deliverablesData, setDeliverablesData] = useState([])
  //assigned history modal
  const [historyModal, setHistoryModal] = useState(false)

  //Data Table section
  const deliverTable = !isEmpty(deliver_list) && deliver_list.length > 0 ?
    deliver_list.map((data, index) => {
      const colorCode =
        !isEmpty(deliverMetaData) &&
        deliverMetaData.processStatusOptions &&
        deliverMetaData.processStatusOptions.length > 0 &&
        deliverMetaData.processStatusOptions.find(
          (_) => _.processStatusId === data.productionprocessstatus
        ) &&
        deliverMetaData.processStatusOptions.find(
          (_) => _.processStatusId === data.productionprocessstatus
        )?.colorCode


      const teamLeadName = !isEmpty(data.assignedTeamlead)
        ? data.assignedTeamlead
          .map((employee) => employee.empCode + "-" + employee.name)
          .join(", ")
        : ""

      const employeeName = !isEmpty(data.assignedEmployee)
        ? data.assignedEmployee
          .map((employee) => employee.empCode + "-" + employee.name)
          .join(", ")
        : ""
      const crmName = !isEmpty(data.assignedCrmEmployee)
        ? data.assignedCrmEmployee
          .map((employee) => employee.empCode + "-" + employee.name)
          .join(", ")
        : ""
      const sheet =
        isEmpty(data.sheetLength) && data.sheetLength == null
          ? 0
          : data.sheetLength

      const sheetValue = sheet + "/" + data.count
      const dataDetails = !isEmpty(data.dataDetail) && data.dataDetail.length > 0 ?
        data.dataDetail[data.dataDetail.length - 1] : []
      const dataValue = !isEmpty(dataDetails) && dataDetails.isDataStatus == true ? "YES" : !
        isEmpty(dataDetails) && dataDetails.isDataStatus == false ? "NO" : "--"

      return {
        sNo: index + 1,
        eventDate: data.eventDate ? moment(data.eventDate).format(dateFormat) : "--",
        productName: data.productName ? data.productName : "--",
        productLeadName: teamLeadName,
        endWorkerName: employeeName,
        crmName: crmName,
        quantity: data.quantity ? data.quantity : "--",
        sheet: sheetValue,
        operationalHistory: data.operationalHistory,
        overallStatus: data.overAllStatus ? data.overAllStatus : "",
        deliverableStatus: data.productioProcessStatusName,
        colorCode: colorCode,
        dataValue:dataValue,

      }
    }) : []


  //assign history api call
  const assignHistory = (data) => {
    const historyPayload = {
      operationId: data.operationId,
      deliverableId: data.leadDelivarableId,
      mode: "POST",
    }
    setHistoryModal(true)
    setTimeout(() => {
      dispatch(
        historyAction.loadProductionAssignHistory(historyPayload)
      )
    }, 500)
  }
  const historyUpdate = useSelector((state) => state.crmManageClient)

  const { history_details = [] } = historyUpdate

  //table columns
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "eventDate",
      text: "Event Date",
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "dataValue",
      text: "Data",
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "productName",
      text: "Product Name",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "crmName",
      text: "Crm Name",
      editable: false,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "productLeadName",
      text: "Product Lead Name",
      editable: false,
      headerStyle: {
        minWidth: "170px",
      },
    },
    {
      dataField: "endWorkerName",
      text: "End Worker Name",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "quantity",
      text: "Quantity",
      headerStyle: {
        minWidth: "130px",
      },
    },

    {
      dataField: "sheet",
      text: "Sheet/Count",
      headerStyle: {
        minWidth: "130px",
      },
    },
    {
      dataField: "deliverables",
      text: "Deliverables",
      headerStyle: {
        minWidth: "130px",
      },
      formatter: (cellContent, row) => {
        return (
          <div>
            <Button className="btn btn-info"
              onClick={() => {
                setDeliverablesData(row.operationalHistory)
                setDeliverablesModal(true)
              }}>
              Deliverables
            </Button>
          </div>
        )
      },
    },

    {
      dataField: "assignHistory",
      text: "Assign History",
      headerStyle: {
        minWidth: "130px",
      },
      formatter: (cellContent, row) => {
        return (
          <div>
            <a
              onClick={() => {
                assignHistory(row)
              }}
            >
              <span
                style={{
                  textDecoration: "underline",
                  color: "#E40D8C",
                }}
              >
                History
              </span>
            </a>
          </div>
        )
      },
    },
    {
      dataField: "overallStatus",
      text: "Overall Status",
      editable: false,
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "deliverableStatus",
      text: "Deliverable Status",
      editable: false,
      formatter: (cellContent, row) => {
        return (
          <div>
            {row.deliverableStatus ? (
              <button
                style={{
                  background: row.colorCode,
                  border: "none",
                  cursor: "pointer",
                  color: "white",
                  padding: "2px",
                  borderRadius: "4px",
                }}
              >
                {row.deliverableStatus}
              </button>
            ) : (
              "--"
            )}
          </div>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]

  // pagination options
  const options = {
    sizePerPage: 10,
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }



  return (
    <React.Fragment>
      <Row className="quote-head-content">
        <p className="quote-head">
          Deliverables
          <span className="quote-info">
            <i
              style={{ color: "grey" }}
              id="DeliverableInfo"
              aria-hidden="true"
              className="fa fa-info-circle ms-1"
            ></i>
            <UncontrolledTooltip placement="right" target="DeliverableInfo">
              Deliverables
            </UncontrolledTooltip>
          </span>
        </p>

        <Col md="12" lg="12" xl="12" className="mt-3">
          <PaginationProvider
            pagination={paginationFactory(options)}
            keyField="_id"
            columns={columns}
          >
            {({ paginationProps, paginationTableProps }) => (
              <ToolkitProvider
                keyField="_id"
                data={deliverTable}
                columns={columns}
                search
                exportCSV
              >
                {(props) => (
                  <div>
                    <Col md="12" xl="12" lg="12" sm="12" xs="12">
                      <Row className="d-flex flex-row  ">

                        <Col>
                          <BootstrapTable
                            {...props.baseProps}
                            responsive
                            striped={true}
                            bordered={true}
                            keyField="_id"
                            columns={columns}
                            {...paginationTableProps}
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginTop: "5px" }}
                        className="align-items-md-center mt-30"
                      >
                        <Col className="inner-custom-pagination d-flex">
                          <div className="d-inline d-flex flex-row">
                            <SizePerPageDropdownStandalone
                              {...paginationProps}
                            />
                            <div
                              style={{
                                fontSize: "14px",
                                marginTop: "8px",
                                marginLeft: "4px",
                              }}
                            >
                              <PaginationTotalStandalone
                                {...paginationProps}
                              />
                            </div>
                          </div>
                          <div
                            className="text-md-right ms-auto"
                            style={{ zIndex: 0 }}
                          >
                            <PaginationListStandalone
                              {...paginationProps}
                            />
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </div>
                )}
              </ToolkitProvider>
            )}
          </PaginationProvider>
        </Col>
        {deliverablesModal && (
          <Modal size="xl" show={deliverablesModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Deliverables
            </Modal.Header>
            <Modal.Body>
              <Row>
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Mode</th>
                      <th>Tat Date</th>
                      <th>Link</th>
                      <th>Remarks</th>
                      <th>Attachment</th>
                      <th>Quantity</th>
                      <th>Created By</th>
                      <th>Created On</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(deliverablesData) && deliverablesData.length > 0 ?
                      deliverablesData.map((data, index) => {


                        const createdOn = !isEmpty(data.createdOn)
                          ? moment.utc(data.createdOn).format(`${dateFormat} ${"hh:mm A"}`)
                          : "--"

                        const attachment = !isEmpty(data.attachment) ? data.attachment.map(m => m).join() : ""
                        const attachExtension = !isEmpty(attachment) ? attachment.split(".").pop() : ""
                        const tatDate = data.tat
                          ? moment(data.tat).format(dateFormat)
                          : "--"
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{data.mode ? data.mode : "--"}</td>
                            <td>{tatDate}</td>
                            <td>{data.link ? data.link : "--"}</td>
                            <td>{data.remarks ? data.remarks : "--"}</td>
                            <td> {(attachment && attachExtension === "jpeg") ||
                              (attachment && attachExtension === "jpg") ||
                              (attachment && attachExtension === "png") ? (
                              <div className="d-flex flex-row align-items-center">
                                <a onClick={() => window.open(attachment, "_blank")}>
                                  <span
                                    style={{
                                      textDecoration: "underline",
                                      color: "#E40D8C",
                                    }}
                                  >
                                    View
                                  </span>
                                </a>
                                <div className="ms-auto ml-2">
                                  <span
                                    style={{
                                      color: "#17b77d"
                                    }}
                                  >

                                    <i className="fa fa-download fa-lg"></i>
                                  </span>

                                </div></div>
                            ) : (attachment && attachExtension === "mp3") ||
                              (attachment && attachExtension === "m4a") ||
                              (attachment && attachExtension === "mp4") ? (
                              <a href={attachment}>
                                <audio controls>
                                  <source src={attachment} type="audio/mpeg" />
                                  Your browser does not support the audio element.
                                </audio>
                              </a>
                            ) : (
                              "--"
                            )}</td>
                            <td>{data.quantity ? data.quantity : "--"}</td>
                            <td>{data.createdByName ? data.createdByName : "--"}</td>
                            <td>{createdOn}</td>
                          </tr>
                        )
                      }) :
                      (<tr>
                        <td className="text-align-center" colSpan={8}>
                          No Records Found...
                        </td>

                      </tr>)}
                  </tbody>
                </Table>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setDeliverablesModal(false)}
              >
                Close
              </Button>

            </Modal.Footer>
          </Modal>
        )}
        {historyModal && (
          <Modal size="xl" show={historyModal}>
            <Modal.Header
              style={{
                backgroundColor: "#E40D8C",
                color: "white",
                fontSize: "16px",
                fontWeight: "600",
              }}
            >
              Assigned History
            </Modal.Header>
            <Modal.Body>
              <Row className="mt-3">
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Type</th>
                      <th>Employee Name</th>
                      <th>Notes</th>
                      <th>Attachment</th>
                      <th>Created On</th>
                      <th>Created By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(history_details) &&
                      history_details.data.length > 0 ? (
                      history_details.data.map((data, index) => {
                        const employeeName =
                          data.PrecrmId !== undefined &&
                            !isEmpty(data.PrecrmId)
                            ? data.PrecrmId.name
                            : data.assignedTeamlead !== undefined &&
                              !isEmpty(data.assignedTeamlead)
                              ? data.assignedTeamlead[0].employeeId
                                .map((employee) => employee.name)
                                .join()
                              : data.assignEmployee !== undefined &&
                                !isEmpty(data.assignEmployee)
                                ? data.assignEmployee[0].employeeId
                                  .map((employee) => employee.name)
                                  .join()
                                : data.assignCrmEmployee !== undefined &&
                                  !isEmpty(data.assignCrmEmployee)
                                  ? data.assignCrmEmployee[0].employeeId
                                    .map((employee) => employee.name)
                                    .join()
                                  : "--"

                        const typeName = data.PrecrmId
                          ? "CRM"
                          : data.assignedTeamlead
                            ? "PL"
                            : data.assignCrmEmployee
                              ? "CRM"
                              : data.assignEmployee
                                ? "EW"
                                : "--"

                        const notesName =
                          data.PrecrmId !== undefined &&
                            !isEmpty(data.PrecrmId) &&
                            data.PrecrmId.notes
                            ? data.PrecrmId.notes
                            : data.assignedTeamlead !== undefined &&
                              !isEmpty(data.assignedTeamlead) &&
                              data.assignedTeamlead[0].notes !== ""
                              ? data.assignedTeamlead[0].notes
                              : data.assignEmployee !== undefined &&
                                !isEmpty(data.assignEmployee) &&
                                data.assignEmployee[0].notes !== ""
                                ? data.assignEmployee[0].notes
                                : data.assignCrmEmployee !== undefined &&
                                  !isEmpty(data.assignCrmEmployee) &&
                                  data.assignCrmEmployee[0].notes !== ""
                                  ? data.assignCrmEmployee[0].notes
                                  : "--"
                        const createdOn =
                          data.PrecrmId !== undefined &&
                            !isEmpty(data.PrecrmId) &&
                            data.PrecrmId.createdOn
                            ? moment
                              .utc(data.PrecrmId.createdOn)
                              .format(`${dateFormat} ${"hh:mm A"}`)
                            : data.assignedTeamlead !== undefined &&
                              !isEmpty(data.assignedTeamlead)
                              ? moment
                                .utc(
                                  data.assignedTeamlead[0].createdOn
                                )
                                .format(`${dateFormat} ${"hh:mm A"}`)
                              : data.assignEmployee !== undefined &&
                                !isEmpty(data.assignEmployee)
                                ? moment
                                  .utc(data.assignEmployee[0].createdOn)
                                  .format(`${dateFormat} ${"hh:mm A"}`)
                                : data.assignCrmEmployee !== undefined &&
                                  !isEmpty(data.assignCrmEmployee)
                                  ? moment
                                    .utc(
                                      data.assignCrmEmployee[0].createdOn
                                    )
                                    .format(`${dateFormat} ${"hh:mm A"}`)
                                  : "--"
                        const createdBy =
                          data.PrecrmId !== undefined &&
                            !isEmpty(data.PrecrmId)
                            ? data.PrecrmId.createdByName
                            : data.assignedTeamlead !== undefined &&
                              !isEmpty(data.assignedTeamlead)
                              ? data.assignedTeamlead[0].createdByName
                              : data.assignEmployee !== undefined &&
                                !isEmpty(data.assignEmployee)
                                ? data.assignEmployee[0].createdByName
                                : data.assignCrmEmployee !== undefined &&
                                  !isEmpty(data.assignCrmEmployee)
                                  ? data.assignCrmEmployee[0].createdByName
                                  : "--"
                        const attachment =
                          data.PrecrmId !== undefined &&
                            !isEmpty(data.PrecrmId)
                            ? data.PrecrmId.attachments
                            : data.assignedTeamlead !== undefined &&
                              !isEmpty(data.assignedTeamlead)
                              ? data.assignedTeamlead[0].attachments
                              : data.assignEmployee !== undefined &&
                                !isEmpty(data.assignEmployee)
                                ? data.assignEmployee[0].attachments
                                : data.assignCrmEmployee !== undefined &&
                                  !isEmpty(data.assignCrmEmployee)
                                  ? data.assignCrmEmployee[0].attachments
                                  : "--"
                        const attachmentValue = !isEmpty(attachment)
                          ? attachment[0]
                          : []
                        const splitAttach = !isEmpty(attachmentValue)
                          ? attachmentValue.split(".")
                          : ""
                        const attachExtension = !isEmpty(splitAttach)
                          ? splitAttach.pop()
                          : ""

                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{typeName}</td>
                            <td>{employeeName}</td>
                            <td>{notesName}</td>
                            <td>
                              {" "}
                              {(attachmentValue &&
                                attachExtension === "jpeg") ||
                                (attachmentValue &&
                                  attachExtension === "jpg") ||
                                (attachmentValue &&
                                  attachExtension === "png") ? (
                                <div className="d-flex flex-row align-items-center">


                                  <a
                                    onClick={() =>
                                      window.open(
                                        attachmentValue,
                                        "_blank"
                                      )
                                    }
                                  >
                                    <span
                                      style={{
                                        textDecoration: "underline",
                                        color: "#E40D8C",
                                      }}
                                    >
                                      View
                                    </span>
                                  </a>

                                </div>
                              ) : (attachmentValue &&
                                attachExtension === "mp3") ||
                                (attachmentValue &&
                                  attachExtension === "m4a") ||
                                (attachmentValue &&
                                  attachExtension === "mp4") ? (
                                <a href={attachmentValue}>
                                  <audio controls>
                                    <source
                                      src={attachmentValue}
                                      type="audio/mpeg"
                                    />
                                    Your browser does not support the
                                    audio element.
                                  </audio>
                                </a>
                              ) : (
                                "--"
                              )}
                            </td>

                            <td>{createdOn}</td>
                            <td>{createdBy}</td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr key={0}>
                        <td className="text-align-center" colSpan={7}>
                          No Records Found...
                        </td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Row>
            </Modal.Body>

            <Modal.Footer>
              <Button
                variant="secondary"
                className="btn btn-danger"
                data-bs-dismiss="modal"
                onClick={() => setHistoryModal(false)}
              >
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        )}
      </Row>
    </React.Fragment>
  )
}
OperationsDeliverables.propTypes = {
  dispatch: PropTypes.func,
  record_quotation_details: PropTypes.array,
  loading: PropTypes.any,
  success: PropTypes.any,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  csvProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(OperationsDeliverables)
)
